<template>
    <div>
        <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiNilai()">Rekapitulasi
            Nilai</v-btn>
        <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiLogbook()">Rekapitulasi
            Logbook</v-btn>
        <!-- <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiDaftarHadir()">Rekapitulasi Daftar
                Hadir</v-btn> -->
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" x-small color="primary" dark v-bind="attrs" v-on="on">
                    Rekapitulasi Daftar Hadir
                </v-btn>
            </template>
            <v-list>
                <v-list-item style="cursor: pointer;">
                    <v-list-item-title @click="gotoRekapitulasiDaftarHadir()">Lihat</v-list-item-title>
                </v-list-item>
                <v-list-item style="cursor: pointer;">
                    <v-list-item-title @click="verifikasiDaftarHadir()">Verifikasi Semua</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiTingkatSupervisi()">Tingkat
            Supervisi</v-btn>
        <v-btn class="mx-2" x-small color="primary" dark @click="gotoRekapitulasiTargetKompetensi()">Target
            Kompetensi</v-btn>
        <router-link :to="{ name: 'AdminUploadSuratSelesai', params: { praktik_id: praktik_id } }"
            style="text-decoration: none;">
            <v-btn class="mx-2" x-small color="success" dark>Upload Surat Selesai Praktik</v-btn>
        </router-link>
    </div>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
export default {
    props: {
        data: { type: Object, default: () => ({}) },
        praktik_id: { type: String, default: () => (null) },
    },
    methods: {
        gotoRekapitulasiNilai() {
            if (this.data.profesi == "Dokter") {
                window.open(
                    process.env.VUE_APP_APIROOT + '/api/ReadFile/viewRekapitulasiDokter/' + this.praktik_id + '/' + this.$store.state.token,
                    '_blank'
                );
            } else if (this.data.profesi == "PPDS") {
                window.open(
                    process.env.VUE_APP_APIROOT + '/api/ReadFile/viewRekapitulasiNilaiPPDS/' + this.praktik_id + '/' + this.$store.state.token,
                    '_blank'
                );
            }
            else if (this.data.profesi == "Keperawatan,Kebidanan, dan Tenaga Kesehatan Lain") {
                window.open(
                    process.env.VUE_APP_APIROOT + '/api/ReadFile/viewRekapitulasiNilaiKeperawatanLain/' + this.praktik_id + '/' + this.$store.state.token,
                    '_blank'
                );
            }
        },
        gotoRekapitulasiLogbook() {
            window.open(
                process.env.VUE_APP_APIROOT + '/api/ReadFile/viewRekapitulasiLogbook/' + this.praktik_id + '/' + this.$store.state.token,
                '_blank'
            );
        },
        gotoRekapitulasiDaftarHadir() {
            window.open(
                process.env.VUE_APP_APIROOT + '/api/ReadFile/viewRekapitulasiDaftarHadir/' + this.praktik_id + '/' + this.$store.state.token,
                '_blank'
            );
        },
        gotoRekapitulasiTingkatSupervisi() {
            window.open(
                process.env.VUE_APP_APIROOT + '/api/ReadFile/viewRekapitulasiTingkatSupervisi/' + this.praktik_id + '/' + this.$store.state.token,
                '_blank'
            );
        },
        gotoRekapitulasiTargetKompetensi() {
            window.open(
                process.env.VUE_APP_APIROOT + '/api/ReadFile/viewRekapitulasiTargetKompetensi/' + this.praktik_id + '/' + this.$store.state.token,
                '_blank'
            );
        },
        verifikasiDaftarHadir() {
            let conf = confirm("Apakah Yakin akan verifikasi daftar hadir?")
            if (conf) {
                const fmData = new FormData()
                fmData.append('praktik_id', this.praktik_id)
                axiosPostAuth('api/DaftarHadir/verifikasiDaftarHadir', fmData)
                    .then(response => {
                        if (response.code === 200) {
                            this.$notify({
                                type: 'success',
                                title: 'Berhasil',
                                text: response.message,
                            });
                        }
                        else {
                            alert(response.message)
                        }
                    })
                    .catch(error => {
                        alert(error)
                    })
            }
        }
    }
}
</script>